export enum DefaultProjectRole {
    ADMIN = 'Admin',
    EDITOR = 'Editor',
    OPERATOR = 'Operator',
    VIEWER = 'Viewer',
}

